// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {alertService} from "../../../services/AlertService";
import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";
import {CargoSelector, getCargo, insertCargo, updateCargo} from "./cargoSlice";

import {Colors} from "../../../assets/Colors";

const CargoPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const Cargo = useSelector(CargoSelector);

    useEffect(() => {
        dispatch(
            getCargo({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {

        if (search !== "" && Cargo.isGetSuccess && !Cargo.isGetFetching) {
            let calc = Cargo?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Cargo.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && Cargo.isGetSuccess && !Cargo.isGetFetching) {
            let calc = Cargo?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Cargo.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !Cargo?.isGetFetching &&
            Cargo.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = Cargo?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Cargo.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getCargo({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (Cargo.isGetSuccess) {
                alertService.success(Cargo.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getCargo({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (Cargo.isUpdateSuccess) {
                alertService.success(Cargo.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateCargo({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetCargo(params) {
    //   return dispatch(getCargo(params));
    // }

    function handleInsertCargo(param) {
        setInsertFetch(true);
        const params = {
            CargoCarryingUnitName: param.inputOneValue,
            CategoryID: param.dropDownCargoValue,
        };
        // 
        dispatch(insertCargo(params));
    }

    function handleUpdateCargo(param) {
        setUpdateFetch(true);

        const params = {
            CargoCarryingUnitName: param.inputOneValue,
            CargoCarryingUnitID: currentData.CargoCarryingUnitID,
            status: param.status,
            CategoryID: param.dropDownCargoValue,

        };
        dispatch(updateCargo(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getCargo(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getCargo(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = Cargo.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? Cargo.count : newCount,
            search: search,
        };
        dispatch(getCargo(params));

        setPage(1);
        setCount(newCount === "-1" ? Cargo.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Cargo"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Cargo"
                                tableData={Cargo.data}
                                colOneTitle="ID"
                                colOneData="CargoCarryingUnitID"
                                colTwoTitle="Nama Cargo"
                                colTwoData="CargoCarryingUnitName"
                                colThreeTitle="Kelompok Cargo"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={Cargo.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownCargo={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Cargo"
                        inputOneTitle="Nama Cargo"
                        inputOneValue=""
                        dropDownCargoValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertCargo}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownCargo={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.CargoCarryingUnitID}
                        modal={handleModal}
                        modalTitle="Ubah Cargo"
                        inputOneTitle="Nama Cargo"
                        inputOneValue={currentData.CargoCarryingUnitName}
                        dropDownCargoValue={currentData.CategoryID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateCargo}
                    />
                )}
            </div>
        );
    }
};

export default CargoPage;
